import * as React from "react";
import { useState, useEffect } from "react";
import { KeyNumberValue } from "../interfaces";

export default function usePagination(
  initialPage: number,
  initialRowsPerPage: number,
  count?: number,
) {
  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  const handleChangePage = (
    event: React.MouseEvent<unknown>,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handlePageJump = (newPage: KeyNumberValue) => {
    setPage(newPage.pageNumber);
    //clears out input
    newPage.pageNumber = 0;
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  useEffect(() => {
    if (count && Math.ceil(count / rowsPerPage) < page) {
      setPage(1);
    }
  }, [count, rowsPerPage, page]);

  return {
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    handleChangePage,
    handlePageJump,
    handleChangeRowsPerPage,
  };
}
